import { FlowLink, FlowNode } from './flow-diagram.component';

// Nodes and links that more than one "How it works" diagram shows, so the wording stays the same on every page.

export const FLOW_AGENT_NODE: FlowNode = {
    title: 'Agent',
    tone: 'private',
    desc: 'Runs in your environment and hosts the share. It makes only outbound connections.',
};

export const FLOW_IPSEC_LINK: FlowLink = { label: 'IPsec', sub: 'encrypted tunnel', zone: 'internet' };

export const FLOW_OVERLAY_LINK: FlowLink = { label: 'mTLS', sub: 'policy-driven', zone: 'overlay' };

/** Remote Site to IPsec Bridge to This Network, on the IPsec Tunnelers list and the tunneler detail. */
export const IPSEC_TUNNELER_FLOW_LINKS: FlowLink[] = [FLOW_IPSEC_LINK, FLOW_OVERLAY_LINK];
